import { Button } from "@sellar-io/components";
import { ReactNode } from "react";
import { useSignupContext } from "../../hooks/useSignupContext.shared";

export const ValuePropsContainer = ({
  title,
  description,
  buttonText,
}: {
  title: string;
  buttonText: string;
  description: ReactNode;
}) => {
  const { setSignupDialogActive } = useSignupContext();
  return (
    <div
      className={
        "flex h-full flex-col justify-between rounded-lg border border-zinc-300 bg-zinc-50 p-8"
      }
    >
      <div className="flex flex-col gap-2">
        <p className={"text-sm font-semibold text-[#B557F1] capitalize"}>
          {title.toUpperCase()}
        </p>
        <p className={"text-2xl font-semibold text-zinc-700"}>{description}</p>
      </div>
      <Button
        className={"mt-6 bg-[#B557F1]"}
        onClick={() => setSignupDialogActive(true)}
      >
        {buttonText}
      </Button>
    </div>
  );
};
